import { render, staticRenderFns } from "./buyorder.vue?vue&type=template&id=1fa0c114&scoped=true&"
import script from "./buyorder.vue?vue&type=script&lang=js&"
export * from "./buyorder.vue?vue&type=script&lang=js&"
import style0 from "./buyorder.vue?vue&type=style&index=0&id=1fa0c114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0c114",
  null
  
)

component.options.__file = "buyorder.vue"
export default component.exports